import { supabase } from '@/lib/supabase';
import { UpdateDto } from '@/shared/types/api';

type PartnerUpdateDto = UpdateDto<'partner_aliases'>;

export const updatePartner = async ({
  partnerId,
  updateDto,
}: {
  partnerId: string;
  updateDto: PartnerUpdateDto;
}): Promise<void> => {
  const { error } = await supabase
    .from('partner_aliases')
    .update(updateDto)
    .eq('id', partnerId);

  if (error) throw error;

  return;
};
